<script>
//
	//Quick body tag hack
	let outBod = document.getElementById("outerBody");
	outBod.classList.add("default");
	outBod.classList.remove("map");
	//
	// end  hack :)
	//
</script>

<section>
	
	<div class="container">
  <h1>404</h1>

  <p><strong>Page not found :(</strong></p>
  <p>The requested page could not be found.</p>
</div>
</section>